import {
  API_ENDPOINT,
  type ClientApiV1CoursesSubscriptionQueryString,
  type CourseCardItem,
  useClientApiV1CoursesSubscriptionQuery,
} from '../../resources/@types/courseSchema';
import { generateQueryKeyUrl } from '../utils/generateQueryKeyUrl';

export const SUBSCRIPTION_COURSES_PAGE_SIZE = 24;

// 계약의 sort 는 열거형이 아니라 문자열이라 화면이 쓰는 값만 여기서 좁힌다
export const SUBSCRIPTION_COURSES_SORT = {
  SEARCH: 'SEARCH',
  POPULAR: 'POPULAR',
  RECENT: 'RECENT',
  RATING: 'RATING',
} as const;

export type SubscriptionCoursesSort =
  (typeof SUBSCRIPTION_COURSES_SORT)[keyof typeof SUBSCRIPTION_COURSES_SORT];

export interface SubscriptionCoursesFilter {
  keyword: string;
  categorySlug: string | null;
  sort: SubscriptionCoursesSort;
  page: number;
}

export type SubscriptionCourseItem = CourseCardItem;

export const SUBSCRIPTION_COURSES_DEFAULT_FILTER: SubscriptionCoursesFilter = {
  keyword: '',
  categorySlug: null,
  sort: SUBSCRIPTION_COURSES_SORT.POPULAR,
  page: 1,
};

function toQueryString(
  filter: SubscriptionCoursesFilter,
): ClientApiV1CoursesSubscriptionQueryString {
  return {
    sort: filter.sort,
    pageNumber: filter.page,
    pageSize: SUBSCRIPTION_COURSES_PAGE_SIZE,
    keyword: filter.keyword || undefined,
    categories: filter.categorySlug || undefined,
  };
}

function getSubscriptionCoursesQueryParams(filter: SubscriptionCoursesFilter) {
  return generateQueryKeyUrl({
    url: API_ENDPOINT.CLIENT_V1_COURSES_SUBSCRIPTION,
    queryParams: toQueryString(filter),
  });
}

export const getSubscriptionCoursesQueryKey = (filter: SubscriptionCoursesFilter) =>
  getSubscriptionCoursesQueryParams(filter).queryKey;

export function useSubscriptionCoursesQuery(
  filter: SubscriptionCoursesFilter,
  { enabled }: { enabled: boolean },
) {
  const query = useClientApiV1CoursesSubscriptionQuery({
    ...getSubscriptionCoursesQueryParams(filter),
    options: {
      enabled,
      keepPreviousData: true,
      staleTime: 1_000 * 10,
    },
  });

  return {
    ...query,
    items: query.data?.items ?? [],
    totalCount: query.data?.totalCount ?? 0,
    totalPage: query.data?.totalPage ?? 0,
  };
}
